import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app.reducer';
import * as themeSelectors from '../../store/selectors/theme.selectors';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.css']
})
export class SidebarNavComponent implements OnInit, OnDestroy {

  menuMode = 'expanded';
  destroy$: Subject<any>;
  constructor(private store: Store<AppState>) {
    this.destroy$ = new Subject<any>();
  }

  ngOnInit(): void {
    this.store.select(themeSelectors.selectMenuMode).pipe(takeUntil(this.destroy$)).subscribe(menuMode => {
      this.menuMode = menuMode;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
